import {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {macroActions} from "_actions";
import {msgSource} from "_constants";
import {
    extractGorgiasCustomFieldsFromMacros,
    extractZendeskCustomFieldsFromMacros,
    isCustomFieldSupported
} from "../CustomFieldUtils";
import _ from "lodash";

export default function (macroId, msgDataSource, msgSourceName) {
    const dispatch = useDispatch();
    const sourceName = _.toString(msgSourceName).toLowerCase()

    useEffect(() => {
        if (isCustomFieldSupported(sourceName) && macroId && msgDataSource) {
            dispatch(macroActions.fetchMacro({macroId, msgDataSource}));
        }
    }, [macroId, msgDataSource]);

    const macros = useSelector(state => state.macro.macros) || [];
    const fetchMacroLoading = useSelector(state => state.macro.fetchMacroLoading);

    const macrosCustomField = useMemo(() => {
        if(!fetchMacroLoading && macros.length > 0) {
            if(sourceName === msgSource.ZENDESK) {
                return extractZendeskCustomFieldsFromMacros(macroId, macros);
            } else if(sourceName === msgSource.GORGIAS) {
                return extractGorgiasCustomFieldsFromMacros(macroId, macros);
            }
        }
    }, [macroId, fetchMacroLoading]) || [];

    return {macrosCustomField, fetchMacroLoading };
}